import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  productBundleComponentsTitle: {
    description: 'products details, bundles tab header',
    defaultMessage: 'Bundle Components',
    id: 'eY2R6n',
  },
  productBundleComponentSku: {
    description: 'products details, bundles tab, component sku header',
    defaultMessage: 'SKU',
    id: '04dO0Q',
  },
  showBundleOnPackingSlip: {
    description: 'products details, bundles tab, show bundle on packing slip label.',
    defaultMessage: 'Show bundle on packing slip',
    id: '4dtjZt',
  },
  productBundleComponentName: {
    description: 'products details, bundles tab, component name header',
    defaultMessage: 'Name',
    id: 'ESkKsE',
  },
  productBundleComponentQuantity: {
    description: 'products details, bundles tab, component quantity header',
    defaultMessage: 'Quantity',
    id: 'Pv+S9N',
  },
  productBundleComponentRemove: {
    description: 'products details, bundles tab, component remove header',
    defaultMessage: 'Remove',
    id: 'pByHph',
  },
  productBundleComponentAdd: {
    description: 'products details, bundles tab, add component button',
    defaultMessage: '{icon} <span>Add Component</span>',
    id: 'APHCxw',
  },
  bundleForSku: {
    description: 'products details, bundles tab, label for individual bundle',
    defaultMessage: 'Bundle for {sku}',
    id: 'fVIYpe',
  },
});
